import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {inject} from "@angular/core";

export const customHomePageGuard: CanActivateFn = (route, state): false => {
    const router: Router = inject(Router);

    let url = localStorage.getItem('homePath')
    const validPathRegex = /^[a-zA-Z0-9\-._~\/?&=]*$/;
    // Check if the URL matches the valid path pattern
    if (url != undefined && url && validPathRegex.test(url) && !url.includes('404') && !url.includes('passthrough')) {
        try {
            const urlTree: UrlTree = router.parseUrl(url);
            // If parseUrl doesn't throw an error, the URL is considered valid
            router.navigateByUrl(url);
        } catch (e) {
            console.warn('Invalid URL:', url);
            // Handle invalid URL scenario
            router.navigateByUrl('/dashboard');
        }
    } else {
        router.navigateByUrl('/dashboard');
    }
    return false;

};